// extracted by mini-css-extract-plugin
export default {"primaryButtonExport":"Button-module--primaryButtonExport--39ba8","secondaryButtonExport":"Button-module--secondaryButtonExport--7a470","wrapper":"TextCard-module--wrapper--388e5"};